
import { Component, Vue} from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component
export default class OtherPartyPopup extends Vue {
    
    @applicationState.State
    public types!: string[]
    
    flmInfo = false;  
    ppmInfo = false;    
    relocInfo = false;
    enfrcInfo = false;

    flmCaseMngmntInfo = false;

    flmPpmInfo = false;    
    relocFlmInfo = false;
    flmEnfrcInfo = false; 

    ppmEnfrcInfo = false;
    relocPpmInfo = false;
    relocEnfrcInfo = false;

    relocFlmPpmInfo = false;
    ppmFlmEnfrcInfo = false;
    relocFlmEnfrcInfo = false;

    ppmRelocEnfrcInfo= false;
    
    allInfo = false;

    mounted(){
        this.needConfirmation()
    }

    public needConfirmation(){

        this.flmInfo = false;
        this.ppmInfo = false;
        this.relocInfo = false;
        this.enfrcInfo = false;        
        this.flmCaseMngmntInfo = false;
        this.flmPpmInfo = false;
        this.ppmEnfrcInfo = false;
        this.relocFlmInfo = false;
        this.flmEnfrcInfo = false;        
        this.relocPpmInfo = false;
        this.relocEnfrcInfo = false;
        this.relocFlmPpmInfo = false;
        this.ppmFlmEnfrcInfo = false;
        this.relocFlmEnfrcInfo = false;
        this.ppmRelocEnfrcInfo = false;
        this.allInfo = false;

        if (this.types.includes("Family Law Matter") || 
            this.types.includes("Priority Parenting Matter") || 
            this.types.includes("Relocation of a Child") || 
            this.types.includes("Enforcement")){
                
                // flm only
            if (this.types.includes("Family Law Matter") && 
                !this.types.includes("Relocation of a Child") && 
                !this.types.includes('Priority Parenting Matter') && 
                !this.types.includes('Enforcement') &&
                !this.types.includes('Case Management')){
                    this.flmInfo = true;

                // ppm only
            } else if (this.types.includes('Priority Parenting Matter') && 
                !this.types.includes("Family Law Matter") && 
                !this.types.includes("Relocation of a Child") &&
                !this.types.includes('Enforcement')) {                    
                    this.ppmInfo = true;

                // reloc only
            } else if(this.types.includes('Relocation of a Child') && 
                !this.types.includes("Family Law Matter") && 
                !this.types.includes("Priority Parenting Matter") &&
                !this.types.includes('Enforcement')){
                    this.relocInfo = true;

                // enforc only    
            } else if (this.types.includes('Enforcement') && 
                !this.types.includes("Family Law Matter") && 
                !this.types.includes("Priority Parenting Matter") &&
                !this.types.includes('Relocation of a Child')){
                    this.enfrcInfo = true;

                // flm and caseManagement only
            } else if (!this.types.includes('Enforcement') && 
                this.types.includes("Family Law Matter") && 
                !this.types.includes("Priority Parenting Matter") &&
                !this.types.includes('Relocation of a Child') &&
                this.types.includes('Case Management')){
                    this.flmCaseMngmntInfo = true;

                // flm and ppm only
            } else if (!this.types.includes('Enforcement') && 
                this.types.includes("Family Law Matter") && 
                this.types.includes("Priority Parenting Matter") &&
                !this.types.includes('Relocation of a Child') &&
                !this.types.includes('Case Management')){
                    this.flmPpmInfo = true;

                // flm and reloc only
            } else if (!this.types.includes('Enforcement') && 
                this.types.includes("Family Law Matter") && 
                !this.types.includes("Priority Parenting Matter") &&
                this.types.includes('Relocation of a Child') &&
                !this.types.includes('Case Management')){
                    this.relocFlmInfo = true;

                // flm and enfrc only
            } else if (this.types.includes('Enforcement') && 
                this.types.includes("Family Law Matter") && 
                !this.types.includes("Priority Parenting Matter") &&
                !this.types.includes('Relocation of a Child') &&
                !this.types.includes('Case Management')){
                    this.flmEnfrcInfo = true;
                    
                // ppm and reloc
            } else if (!this.types.includes("Family Law Matter") && 
                !this.types.includes('Enforcement') &&
                this.types.includes("Priority Parenting Matter") &&
                this.types.includes('Relocation of a Child')){
                    this.relocPpmInfo = true;

                // ppm and enfrc
            } else if (!this.types.includes("Family Law Matter") &&
                this.types.includes('Enforcement') &&
                this.types.includes("Priority Parenting Matter") &&
                !this.types.includes('Relocation of a Child')){
                    this.ppmEnfrcInfo = true;

                // reloc and enfrc
            } else if (!this.types.includes("Family Law Matter") &&
                this.types.includes('Enforcement') &&
                !this.types.includes("Priority Parenting Matter") &&
                this.types.includes('Relocation of a Child')){
                    this.relocEnfrcInfo = true;

                // reloc and flm and ppm
            } else if (this.types.includes("Family Law Matter") &&
                !this.types.includes('Enforcement') &&
                this.types.includes("Priority Parenting Matter") &&
                this.types.includes('Relocation of a Child')){
                    this.relocFlmPpmInfo = true;

                // enfrc and flm and ppm
            } else if (this.types.includes("Family Law Matter") &&
                this.types.includes('Enforcement') &&
                this.types.includes("Priority Parenting Matter") &&
                !this.types.includes('Relocation of a Child')){
                    this.ppmFlmEnfrcInfo = true;

                // enfrc and flm and reloc
            } else if (this.types.includes("Family Law Matter") &&
                this.types.includes('Enforcement') &&
                !this.types.includes("Priority Parenting Matter") &&
                this.types.includes('Relocation of a Child')){
                    this.relocFlmEnfrcInfo = true;                
                 // enfrc and flm and reloc
            } else if (!this.types.includes("Family Law Matter") &&
                this.types.includes('Enforcement') &&
                this.types.includes("Priority Parenting Matter") &&
                this.types.includes('Relocation of a Child')){
                    this.ppmRelocEnfrcInfo = true;
            }else{
                console.log('else')
                this.allInfo = true;
            }            
        }
    }

}
